// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.callrequest-loader {
	display: block;
	height: 150px;
	position: relative;
	width: 100%;
}
.loader {
	-webkit-animation: outer-rotate 2.91667s linear infinite;
	        animation: outer-rotate 2.91667s linear infinite;
	left: 50%;
	margin-left: -50px;
	overflow: hidden;
	position: absolute;
	top: calc(50% - 50px);
}
.loader__inner {
	-webkit-animation: sporadic-rotate 5.25s cubic-bezier(0.35, 0, 0.25, 1) infinite;
	        animation: sporadic-rotate 5.25s cubic-bezier(0.35, 0, 0.25, 1) infinite;
	display: inline-block;
	height: 100px;
	position: relative;
	width: 100px;
}
.loader__gap {
	border-top: 10px solid;
	bottom: 0;
	-webkit-box-sizing: border-box;
	        box-sizing: border-box;
	left: 49px;
	position: absolute;
	right: 49px;
	top: 0;
}
.loader__left,
.loader__right {
	height: 100px;
	overflow: hidden;
	position: absolute;
	top: 0;
	width: 50px;
}
.loader__left {
	left: 0;
}
.loader__right {
	right: 0;
}
.loader__half-circle {
	border-color: #52ae30 #52ae30 transparent #52ae30;
	border-radius: 50%;
	border-style: solid;
	border-width: 10px;
	-webkit-box-sizing: border-box;
	        box-sizing: border-box;
	height: 100px;
	position: absolute;
	top: 0;
	width: 100px;
}
.loader__left .loader__half-circle {
	-webkit-animation: left-wobble 1.3125s cubic-bezier(0.35, 0, 0.25, 1) infinite;
	        animation: left-wobble 1.3125s cubic-bezier(0.35, 0, 0.25, 1) infinite;
	border-right-color: transparent;
	left: 0;
}
.loader__right .loader__half-circle {
	-webkit-animation: right-wobble 1.3125s cubic-bezier(0.35, 0, 0.25, 1) infinite;
	        animation: right-wobble 1.3125s cubic-bezier(0.35, 0, 0.25, 1) infinite;
	border-left-color: transparent;
	right: 0;
}
@-webkit-keyframes outer-rotate {
0% {
		-webkit-transform: rotate(0deg) scale(0.5);
		        transform: rotate(0deg) scale(0.5);
}
100% {
		-webkit-transform: rotate(360deg) scale(0.5);
		        transform: rotate(360deg) scale(0.5);
}
}
@keyframes outer-rotate {
0% {
		-webkit-transform: rotate(0deg) scale(0.5);
		        transform: rotate(0deg) scale(0.5);
}
100% {
		-webkit-transform: rotate(360deg) scale(0.5);
		        transform: rotate(360deg) scale(0.5);
}
}
@-webkit-keyframes left-wobble {
0%,
	100% {
		-webkit-transform: rotate(130deg);
		        transform: rotate(130deg);
}
50% {
		-webkit-transform: rotate(-5deg);
		        transform: rotate(-5deg);
}
}
@keyframes left-wobble {
0%,
	100% {
		-webkit-transform: rotate(130deg);
		        transform: rotate(130deg);
}
50% {
		-webkit-transform: rotate(-5deg);
		        transform: rotate(-5deg);
}
}
@-webkit-keyframes right-wobble {
0%,
	100% {
		-webkit-transform: rotate(-130deg);
		        transform: rotate(-130deg);
}
50% {
		-webkit-transform: rotate(5deg);
		        transform: rotate(5deg);
}
}
@keyframes right-wobble {
0%,
	100% {
		-webkit-transform: rotate(-130deg);
		        transform: rotate(-130deg);
}
50% {
		-webkit-transform: rotate(5deg);
		        transform: rotate(5deg);
}
}
@-webkit-keyframes sporadic-rotate {
12.5% {
		-webkit-transform: rotate(135deg);
		        transform: rotate(135deg);
}
25% {
		-webkit-transform: rotate(270deg);
		        transform: rotate(270deg);
}
37.5% {
		-webkit-transform: rotate(405deg);
		        transform: rotate(405deg);
}
50% {
		-webkit-transform: rotate(540deg);
		        transform: rotate(540deg);
}
62.5% {
		-webkit-transform: rotate(675deg);
		        transform: rotate(675deg);
}
75% {
		-webkit-transform: rotate(810deg);
		        transform: rotate(810deg);
}
87.5% {
		-webkit-transform: rotate(945deg);
		        transform: rotate(945deg);
}
100% {
		-webkit-transform: rotate(1080deg);
		        transform: rotate(1080deg);
}
}
@keyframes sporadic-rotate {
12.5% {
		-webkit-transform: rotate(135deg);
		        transform: rotate(135deg);
}
25% {
		-webkit-transform: rotate(270deg);
		        transform: rotate(270deg);
}
37.5% {
		-webkit-transform: rotate(405deg);
		        transform: rotate(405deg);
}
50% {
		-webkit-transform: rotate(540deg);
		        transform: rotate(540deg);
}
62.5% {
		-webkit-transform: rotate(675deg);
		        transform: rotate(675deg);
}
75% {
		-webkit-transform: rotate(810deg);
		        transform: rotate(810deg);
}
87.5% {
		-webkit-transform: rotate(945deg);
		        transform: rotate(945deg);
}
100% {
		-webkit-transform: rotate(1080deg);
		        transform: rotate(1080deg);
}
}
`, "",{"version":3,"sources":["webpack://./src/common/css/loader.css"],"names":[],"mappings":"AAAA;CACC,cAAc;CACd,aAAa;CACb,kBAAkB;CAClB,WAAW;AACZ;AAEA;CACC,wDAAgD;SAAhD,gDAAgD;CAChD,SAAS;CACT,kBAAkB;CAClB,gBAAgB;CAChB,kBAAkB;CAClB,qBAAqB;AACtB;AAEA;CACC,gFAAwE;SAAxE,wEAAwE;CACxE,qBAAqB;CACrB,aAAa;CACb,kBAAkB;CAClB,YAAY;AACb;AAEA;CACC,sBAAsB;CACtB,SAAS;CACT,8BAAsB;SAAtB,sBAAsB;CACtB,UAAU;CACV,kBAAkB;CAClB,WAAW;CACX,MAAM;AACP;AAEA;;CAEC,aAAa;CACb,gBAAgB;CAChB,kBAAkB;CAClB,MAAM;CACN,WAAW;AACZ;AAEA;CACC,OAAO;AACR;AAEA;CACC,QAAQ;AACT;AAEA;CACC,iDAAiD;CACjD,kBAAkB;CAClB,mBAAmB;CACnB,kBAAkB;CAClB,8BAAsB;SAAtB,sBAAsB;CACtB,aAAa;CACb,kBAAkB;CAClB,MAAM;CACN,YAAY;AACb;AAEA;CACC,8EAAsE;SAAtE,sEAAsE;CACtE,+BAA+B;CAC/B,OAAO;AACR;AAEA;CACC,+EAAuE;SAAvE,uEAAuE;CACvE,8BAA8B;CAC9B,QAAQ;AACT;AAEA;AACC;EACC,0CAAkC;UAAlC,kCAAkC;AACnC;AACA;EACC,4CAAoC;UAApC,oCAAoC;AACrC;AACD;AAPA;AACC;EACC,0CAAkC;UAAlC,kCAAkC;AACnC;AACA;EACC,4CAAoC;UAApC,oCAAoC;AACrC;AACD;AAEA;AACC;;EAEC,iCAAyB;UAAzB,yBAAyB;AAC1B;AACA;EACC,gCAAwB;UAAxB,wBAAwB;AACzB;AACD;AARA;AACC;;EAEC,iCAAyB;UAAzB,yBAAyB;AAC1B;AACA;EACC,gCAAwB;UAAxB,wBAAwB;AACzB;AACD;AAEA;AACC;;EAEC,kCAA0B;UAA1B,0BAA0B;AAC3B;AACA;EACC,+BAAuB;UAAvB,uBAAuB;AACxB;AACD;AARA;AACC;;EAEC,kCAA0B;UAA1B,0BAA0B;AAC3B;AACA;EACC,+BAAuB;UAAvB,uBAAuB;AACxB;AACD;AAEA;AACC;EACC,iCAAyB;UAAzB,yBAAyB;AAC1B;AACA;EACC,iCAAyB;UAAzB,yBAAyB;AAC1B;AACA;EACC,iCAAyB;UAAzB,yBAAyB;AAC1B;AACA;EACC,iCAAyB;UAAzB,yBAAyB;AAC1B;AACA;EACC,iCAAyB;UAAzB,yBAAyB;AAC1B;AACA;EACC,iCAAyB;UAAzB,yBAAyB;AAC1B;AACA;EACC,iCAAyB;UAAzB,yBAAyB;AAC1B;AACA;EACC,kCAA0B;UAA1B,0BAA0B;AAC3B;AACD;AAzBA;AACC;EACC,iCAAyB;UAAzB,yBAAyB;AAC1B;AACA;EACC,iCAAyB;UAAzB,yBAAyB;AAC1B;AACA;EACC,iCAAyB;UAAzB,yBAAyB;AAC1B;AACA;EACC,iCAAyB;UAAzB,yBAAyB;AAC1B;AACA;EACC,iCAAyB;UAAzB,yBAAyB;AAC1B;AACA;EACC,iCAAyB;UAAzB,yBAAyB;AAC1B;AACA;EACC,iCAAyB;UAAzB,yBAAyB;AAC1B;AACA;EACC,kCAA0B;UAA1B,0BAA0B;AAC3B;AACD","sourcesContent":[".callrequest-loader {\n\tdisplay: block;\n\theight: 150px;\n\tposition: relative;\n\twidth: 100%;\n}\n\n.loader {\n\tanimation: outer-rotate 2.91667s linear infinite;\n\tleft: 50%;\n\tmargin-left: -50px;\n\toverflow: hidden;\n\tposition: absolute;\n\ttop: calc(50% - 50px);\n}\n\n.loader__inner {\n\tanimation: sporadic-rotate 5.25s cubic-bezier(0.35, 0, 0.25, 1) infinite;\n\tdisplay: inline-block;\n\theight: 100px;\n\tposition: relative;\n\twidth: 100px;\n}\n\n.loader__gap {\n\tborder-top: 10px solid;\n\tbottom: 0;\n\tbox-sizing: border-box;\n\tleft: 49px;\n\tposition: absolute;\n\tright: 49px;\n\ttop: 0;\n}\n\n.loader__left,\n.loader__right {\n\theight: 100px;\n\toverflow: hidden;\n\tposition: absolute;\n\ttop: 0;\n\twidth: 50px;\n}\n\n.loader__left {\n\tleft: 0;\n}\n\n.loader__right {\n\tright: 0;\n}\n\n.loader__half-circle {\n\tborder-color: #52ae30 #52ae30 transparent #52ae30;\n\tborder-radius: 50%;\n\tborder-style: solid;\n\tborder-width: 10px;\n\tbox-sizing: border-box;\n\theight: 100px;\n\tposition: absolute;\n\ttop: 0;\n\twidth: 100px;\n}\n\n.loader__left .loader__half-circle {\n\tanimation: left-wobble 1.3125s cubic-bezier(0.35, 0, 0.25, 1) infinite;\n\tborder-right-color: transparent;\n\tleft: 0;\n}\n\n.loader__right .loader__half-circle {\n\tanimation: right-wobble 1.3125s cubic-bezier(0.35, 0, 0.25, 1) infinite;\n\tborder-left-color: transparent;\n\tright: 0;\n}\n\n@keyframes outer-rotate {\n\t0% {\n\t\ttransform: rotate(0deg) scale(0.5);\n\t}\n\t100% {\n\t\ttransform: rotate(360deg) scale(0.5);\n\t}\n}\n\n@keyframes left-wobble {\n\t0%,\n\t100% {\n\t\ttransform: rotate(130deg);\n\t}\n\t50% {\n\t\ttransform: rotate(-5deg);\n\t}\n}\n\n@keyframes right-wobble {\n\t0%,\n\t100% {\n\t\ttransform: rotate(-130deg);\n\t}\n\t50% {\n\t\ttransform: rotate(5deg);\n\t}\n}\n\n@keyframes sporadic-rotate {\n\t12.5% {\n\t\ttransform: rotate(135deg);\n\t}\n\t25% {\n\t\ttransform: rotate(270deg);\n\t}\n\t37.5% {\n\t\ttransform: rotate(405deg);\n\t}\n\t50% {\n\t\ttransform: rotate(540deg);\n\t}\n\t62.5% {\n\t\ttransform: rotate(675deg);\n\t}\n\t75% {\n\t\ttransform: rotate(810deg);\n\t}\n\t87.5% {\n\t\ttransform: rotate(945deg);\n\t}\n\t100% {\n\t\ttransform: rotate(1080deg);\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
